import Api from 'api/v2/Api';

class InsightsEventsApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/directoryinsights';
  }

  /**
   * The fetch calls below use a POST call instead of a GET call due to axios not supporting
   * passing a request body in a GET call.
   * @see: https://www.elastic.co/guide/en/elasticsearch/reference/current/search-request-body.html
   * @see: https://stackoverflow.com/questions/54810942/send-a-get-request-with-a-body-in-javascript-xmlhttprequest
   */
  async fetch(payload) {
    await this.initialize();
    const response = await this.axios.post(`${this.baseUrl}/events`, payload);
    if (response && response.data) {
      response.data.map(async (element) => {
        const sanitizable = element;
        if (sanitizable?.useragent?.os === 'Mac OS X') {
          sanitizable.useragent.os = 'macOS';
        }

        return sanitizable;
      });
    }

    return response;
  }

  async fetchCount(payload) {
    await this.initialize();
    return this.axios.post(`${this.baseUrl}/events/count`, payload);
  }

  async fetchDistinct(payload) {
    await this.initialize();
    return this.axios.post(`${this.baseUrl}/events/distinct`, payload);
  }

  async fetchMultiDistinct(payload) {
    await this.initialize();
    return this.axios.post(`${this.baseUrl}/events/multi-distinct`, payload);
  }

  async fetchGraphView(params) {
    await this.initialize();
    return this.axios.get(`${this.baseUrl}/graph_view?${this.param(params)}`);
  }

  async fetchIntervalCount(payload) {
    await this.initialize();
    return this.axios.post(`${this.baseUrl}/events/interval`, payload);
  }

  /**
   * Saved Views
   */
  async createView(payload) {
    await this.initialize();
    return this.axios.post(`${this.baseUrl}/views`, payload);
  }

  async deleteView(id) {
    await this.initialize();
    return this.axios.delete(`${this.baseUrl}/views/${id}`);
  }

  async fetchView(id) {
    await this.initialize();
    return this.axios.get(`${this.baseUrl}/views/${id}`);
  }

  async fetchViews() {
    await this.initialize();
    return this.axios.get(`${this.baseUrl}/views`);
  }

  async updateView(id, payload) {
    await this.initialize();
    return this.axios.put(`${this.baseUrl}/views/${id}`, payload);
  }
}

export default new InsightsEventsApi();
